var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showLightbox),expression:"showLightbox"}]},[_c('CoolLightBox',{attrs:{"items":[_vm.lightBoxUrl],"index":_vm.showLightbox ? 0 : null,"slideshow":false,"useZoomBar":true},on:{"close":_vm.dismiss}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }